import {parallax} from "./parallax";

export function testimonialParallax() {
    $(".testimonial").each(function (){
        $(this).append(`<span class="shadow top has-parallax" data-speed="30"></span>
                <span class="shadow bottom has-parallax" data-speed="30"></span>`)
        parallax.call($(this));
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonialParallax.js